import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Store } from "@ngxs/store";
import { map } from "rxjs";
import { Theme, UIActions } from "../../state/ui.actions";
import { UIState } from "../../state/ui.state";

@Component({
    selector: "dtm-ui-dark-mode-toggle",
    templateUrl: "./dark-mode-toggle.component.html",
    styleUrls: ["./dark-mode-toggle.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DarkModeToggleComponent {
    constructor(private readonly store: Store) {}

    protected isDarkMode$ = this.store.select(UIState.theme).pipe(map((theme) => theme === Theme.Dark));

    protected setDarkMode(isDarkMode: boolean): void {
        this.store.dispatch(new UIActions.SetTheme(isDarkMode ? Theme.Dark : Theme.Light));
    }
}
